import React, { useState } from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Grid, Divider, Button } from "@mui/material";
import PropTypes from "prop-types";
import exportDownloadIcon from "assets/images/exportDownloadIcon.svg";

function DateRangePickerComponent({
  handleExportData,
  handleChange,
  datePickerValue,
}) {
  const [startDate] = useState(null);

  const exportCSV = () => {
    handleExportData();
  };
  return (
    <div className="b-container-range">
      <Grid container spacing={0}>
        <Grid item xs={0.5}>
          <CalendarMonthIcon />
        </Grid>
        <Grid item xs={0.5} />
        <Grid item xs={6} md={6}>
          {/* ************************************************** */}
          {/* Date Range Picker */}
          {/* ************************************************** */}
          <DateRangePicker
            value={datePickerValue}
            onChange={handleChange}
            calendarIcon={null}
            clearIcon={null}
            yearPlaceholder="2022"
            dayPlaceholder="5"
            monthPlaceholder="september"
          />
          <Divider />
          <div className="b-container-range__errorMsg errorMsg">
            {startDate}
          </div>
        </Grid>
      </Grid>
      <div className="b-btn-container__main">
        <Button
          className="font-bold b-btn-container__export"
          variant="outlined"
          onClick={exportCSV}
        >
          <img
            className="b-btn-container__export-icon"
            src={exportDownloadIcon}
            alt=""
          />
          Export and Download
        </Button>
      </div>
    </div>
  );
}

DateRangePickerComponent.propTypes = {
  handleExportData: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  datePickerValue: PropTypes.string.isRequired,
};
export default DateRangePickerComponent;
